import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IEmailAddress } from 'src/app/models/interfaces/email-address.interface';

export class EmailAddressDetailContext extends DefaultDetailContext<IEmailAddress, number> {}
